import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { ProductType } from '../../../shared/enums/product-type';
import { Guid, Nillable } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { PublicCartItemAttributeResponse } from './public-cart-item-attribute.response';
import { PublicCartItemStatusResponse } from './public-cart-item-status.response';

@jsonObject
export class PublicCartItemCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly subName?: Nillable<string>;

  @jsonMember(String)
  public readonly slug?: Nillable<string>;

  @jsonMember(String)
  public readonly type!: ProductType;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(Number)
  public readonly unitPrice!: number;

  @jsonMember(Number)
  public readonly price!: number;

  @jsonMember(PublicCartItemStatusResponse)
  public readonly status!: PublicCartItemStatusResponse;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile!: MultimediaResponse;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonArrayMember(PublicCartItemAttributeResponse)
  public readonly attributes!: PublicCartItemAttributeResponse[];
}
